import { getItineraryCustomizationInfo } from "../../itinerary/repo/itineraryRepo";
import type {
  ItineraryCustomizationInfo,
  ItineraryCustomizationInfoRow,
} from "../../itinerary/types";

export type { ItineraryCustomizationInfo, ItineraryCustomizationInfoRow };

/** 读取行程关联的定制信息，并转换为编辑器右栏的只读展示行。 */
export async function fetchItineraryCustomizationInfo(
  itineraryId: string,
): Promise<ItineraryCustomizationInfo> {
  return getItineraryCustomizationInfo(itineraryId);
}
